<template>
  <view flex="dir:left cross:center main:left" class="pft-tip-container" :style="style">
    <view :class="{ 'pft-tip__icon': hasTitleIcon }">
      <slot name="icon"></slot>
    </view>
    <view class="pft-tip__content">
      <slot></slot>
    </view>
  </view>
</template>
<script lang="ts" setup>
import { useSlots } from "vue"
withDefaults(
  defineProps<{
    style?: { [key: string]: string }
  }>(),
  {
    style: () => ({}),
  },
)
let slots = useSlots()
const hasTitleIcon = !!slots["icon"]
</script>
<style lang="scss">
.pft-tip-container {
  padding: 7px;
  background: rgba(29, 45, 71, 0.75);
  border-radius: 12px;
  margin: 8px 16px;
  .pft-tip__icon {
    margin-right: 10px;
  }
  .pft-tip__content {
    font-family:
      Segoe UI,
      Segoe UI;
    font-weight: 400;
    font-size: 12px;
    color: #a3a6ad;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
</style>
